// extracted by mini-css-extract-plugin
export var inner = "Section-module--inner--128e4";
export var section = "Section-module--section--da26a";
export var thinner = "Section-module--thinner--9f0e2";